import { APICore } from './apiCore'

const api = new APICore()

function getStructureItems (params) {
  const baseUrl = '/structure-items'
  return api.get(baseUrl, params)
}

function getStructureItem (id) {
  const baseUrl = `/structure-items/${id}`
  return api.get(baseUrl, {})
}

function addStructureItem (params) {
  const baseUrl = '/structure-items'
  return api.createWithFile(baseUrl, params)
}

function updateStructureItem (params) {
  const baseUrl = '/structure-items'
  return api.updateWithFile(baseUrl, params)
}

function deleteStructureItem (params) {
  const baseUrl = '/structure-items'
  return api.delete(baseUrl, params)
}

export { getStructureItems, getStructureItem, addStructureItem, updateStructureItem, deleteStructureItem }
